<template>
  <div
    class="overflow-y-auto"
    :class="
      variant === 'modal'
        ? '-mb-5 h-[666px] pb-5'
        : 'min-h-0 flex-1 pb-[env(safe-area-inset-bottom)]'
    "
  >
    <div :class="variant === 'modal' ? 'px-6' : 'px-[13px]'">
      <CheckerMediaCard :results="results" />
    </div>
    <div :class="variant === 'modal' ? 'pl-6' : 'pl-[13px]'">
      <h3
        class="pt-5 pb-2.5 text-[24px] leading-[28px] font-medium text-gray-800"
      >
        {{ heading }}
      </h3>
      <div class="h-px bg-[#2d2d2d]/8" />
      <CheckerMatchRow
        v-for="finding in results.findings"
        :key="findingKey(finding)"
        :finding="finding"
        :results="results"
        @open="checker.openMatch(finding)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CheckerMatchRow from './CheckerMatchRow.vue'
import CheckerMediaCard from './CheckerMediaCard.vue'
import { findingKey } from './findings'
import type { CheckerResults } from './results'
import { useChecker } from './useChecker'

const props = defineProps<{
  variant: 'modal' | 'sheet'
  results: CheckerResults
}>()

const checker = useChecker()

const heading = computed(() => {
  const count = props.results.findings.length
  return `${count} possible ${count === 1 ? 'match' : 'matches'}`
})
</script>
